<template>
  <base-warning v-model="modelValue">
    <div class="d-flex flex-column">
      <p>
        Para solicitar esse medicamento via <span class="font-weight-bold"></span>, atente-se para às seguintes
        exigências:
      </p>
      <div v-html="asthmaRequirements['asma-eosinofilica-grave']" />
    </div>
  </base-warning>
</template>

<script>
import { ComputedOptions } from 'vue'
import BaseWarning from '../BaseWarning.vue'
import asthmaRequirements from './helper/commonRequirements'

export default {
  components: { BaseWarning },
  name: 'ConductWarning.Mepolizumabe40',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asthmaRequirements,
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
